import script from "./addHouse.vue?vue&type=script&setup=true&lang=js"
export * from "./addHouse.vue?vue&type=script&setup=true&lang=js"

import "./addHouse.vue?vue&type=style&index=0&id=37901358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37901358"]])

export default __exports__